import React from "react"

const ProductRecipes = ( { recipes } ) => {
    const productRecipes = recipes && recipes.map((item, i) => {
      return (
        <li key={i}>
          <img src={ item.weight[0].card_image_main } alt={ item.recipe } />
          <p>
              { item.recipe }
          </p>
        </li>
      )
    })
  
    if (!productRecipes || !productRecipes.length) return null
  
    return (
      <ul className="product--more-recipes">
        { productRecipes }
      </ul>
    )
}

export default ProductRecipes